var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgHeartEcgShield(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("g", {
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M27.76 6.452l-5.6-2.419a.397.397 0 00-.316 0l-5.6 2.419a.4.4 0 00-.24.367v3.378A6.274 6.274 0 0014.4 11.82 5.79 5.79 0 009.584 9.2C6.14 9.2 4 11.508 4 15.223a7.52 7.52 0 00.833 3.576H4.4a.4.4 0 000 .8h.926a13.484 13.484 0 001.844 2.029c.226.213.445.42.65.628 1.474 1.495 6.122 5.48 6.319 5.647a.4.4 0 00.52 0c.197-.17 4.846-4.152 6.32-5.647.204-.207.423-.415.648-.628a12.663 12.663 0 001.977-2.209c.463-.7.796-1.48.982-2.3l1.697-1.208A4.074 4.074 0 0028 12.604V6.819a.4.4 0 00-.24-.367zM4.801 15.224C4.801 11.953 6.59 10 9.585 10s4.316 2.494 4.456 2.778a.4.4 0 00.718 0A5.433 5.433 0 0116 11.212v1.393a4.074 4.074 0 001.715 3.308l.374.267-.787 2.621H16a.4.4 0 00-.358.221l-.61 1.219-.636-5.09a.4.4 0 00-.78-.065L12.504 18.8h-1.302a.4.4 0 00-.32.16l-.63.84-.655-4.26a.4.4 0 00-.774-.066L7.712 18.8h-1.96a6.63 6.63 0 01-.95-3.576zm18.137 3.756c-.536.76-1.16 1.454-1.858 2.068-.232.22-.458.434-.668.647-1.255 1.271-4.99 4.499-6.011 5.378-1.021-.88-4.757-4.107-6.011-5.378-.21-.213-.436-.427-.669-.647A15.684 15.684 0 016.323 19.6h1.678a.4.4 0 00.38-.274l.676-2.03.549 3.565a.4.4 0 00.715.179l1.08-1.44h1.4a.4.4 0 00.383-.285l.657-2.184.564 4.52a.4.4 0 00.396.349.4.4 0 00.358-.221l1.089-2.179H17.6a.4.4 0 00.383-.285l.667-2.22.553 4.158a.4.4 0 00.74.153l1.2-2a.4.4 0 10-.686-.412l-.612 1.02-.38-2.854 2.12 1.51c.248.176.58.176.828 0l1.1-.784a6.25 6.25 0 01-.576 1.094zm4.262-6.376a3.272 3.272 0 01-1.38 2.657L22 17.98l-3.82-2.72a3.272 3.272 0 01-1.38-2.657V7.082L22 4.836l5.2 2.246v5.522z"
  }), React.createElement("path", {
    d: "M21.84 5.776l-4 1.728a.4.4 0 00-.24.367v4.733a2.472 2.472 0 001.044 2.005l3.124 2.224a.4.4 0 00.464 0l3.125-2.224a2.472 2.472 0 001.043-2.005V7.87a.4.4 0 00-.24-.367l-4-1.728a.4.4 0 00-.32 0zm3.76 2.36v4.468a1.67 1.67 0 01-.707 1.354L22 16.017l-2.892-2.06a1.67 1.67 0 01-.708-1.353v-4.47L22 6.579l3.6 1.557z"
  }), React.createElement("path", {
    d: "M19.84 11.68a.4.4 0 10-.48.64l1.6 1.2a.4.4 0 00.553-.07l3.2-4a.4.4 0 00-.625-.5l-2.96 3.698-1.288-.968z"
  })));
}

export default SvgHeartEcgShield;